import { useEffect, useState } from 'react';
import { CommunicationClient } from '../services/apiClient'; 
import { API_BASE_URL } from '../config/config';
import axiosInstance from "../services/axiosInstance";

const useCommunicationLists = () => {
    const [communicationLists, setCommunicationLists] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const communicationClient = new CommunicationClient(API_BASE_URL, axiosInstance);

    useEffect(() => {
        const fetchCommunicationLists = async () => {
            setIsLoading(true);
            try {
                const lists = await communicationClient.getAllCommunicationLists();
                if (lists && lists.success && lists.data) {
                    setCommunicationLists(lists.data);
                } else {
                    setError('Failed to fetch communication lists');
                }
            } catch (err) {
                setError('Error fetching communication lists');
                console.error('Error fetching communication lists:', err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCommunicationLists();
    }, []);

    return { communicationLists, isLoading, error };
};

export default useCommunicationLists;
